module.exports = __webpack_public_path__ + "static/cupcake-pattern-ba5c6777daa8d6bbc8a38306626857c8.png";